import React, { Component } from 'react'

export default class FrequencyCard extends Component {
  render() {
    const { head, content, isActive, occur_frequency } = this.props;
    return (
      <div className={`alloc-freq-col${isActive ? ' alloc-freq-col--active' : ''}`}>
        <div className="alloc-freq-col__header">
          <p className="alloc-freq-col__name">{head}</p>
          {occur_frequency !== undefined && (
            <p className="alloc-freq-col__count">x{occur_frequency}</p>
          )}
        </div>
        <div className="alloc-freq-col__body">
          {content}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Cards/frequency_card.js